export const DEFAULT_FONT_FAMILY = 'Helvetica, Arial, sans-serif';